import { Controller } from "@hotwired/stimulus"
import { FormHelper } from "~/helpers/form_helper"

export default class extends Controller {
  static targets = ["form", "fullName", "newCard", "paymentMethodId", "submitButton"]

  static values = { stripeKey: String }

  initialize() {
    var _this = this

    App.whenAvailable("Stripe", function () {
      _this.initializeStripe()
      _this.loadStripeElements()
    })
  }

  initializeStripe() {
    this.stripe = Stripe(this.stripeKeyValue)
  }

  loadStripeElements() {
    this.card = this.stripe.elements().create("card", FormHelper.elementStyles("15px"))
    this.card.mount("#card-field")
  }

  submit(e) {
    e.preventDefault()

    FormHelper.disableForm(this.submitButtonTarget)

    var _this = this

    var billingDetails = {
      name: this.fullNameTarget.value,
      address: {
        line1: gon.billing_information_address,
        city: gon.billing_information_city,
        postal_code: gon.billing_information_postal_code,
        country: gon.billing_information_country_code
      },
      email: gon.user.email
    }

    this.stripe.createPaymentMethod({ type: "card", card: this.card, billing_details: billingDetails }).then(function (result) {
      if (result.error) {
        // The payment method creation on the Stripe side failed.
        FormHelper.displayFlashError(result.error.message)
        return FormHelper.enableForm()
      }

      // The payment method creation on the Stripe side succeeded.
      _this.paymentMethodIdTarget.value = result.paymentMethod.id
      _this.formTarget.requestSubmit()
    })
  }
}
